module.exports = __webpack_public_path__ + "img/soccerboard25.bf89c1db.jpg";